<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="role('admin', 'safetyRepresentative', 'departmentManager', 'manager')"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="
          role('admin', 'safetyRepresentative', 'departmentManager', 'manager')
        "
        v-on="on"
        small
        class="primary accent-4 white--text mr-2 my-1"
      >
        {{ $t(`profile.assignment.changeManager`) }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t(`profile.assignment.changeManager`) }}
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          class="mt-0 pt-0"
          v-model="selectedManager"
          :items="employees"
          required
          chips
          deletable-chips
          :item-text="(e) => `${$options.filters.nameId(e)}`"
          return-object
        />
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="change" :loading="loading">{{
          $t("dialog.change")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import EmployeesQuery from "@/graphql/Employees.gql";

import ChangeManager from "@/graphql/mutation/profile/ChangeManager.gql";

export default {
  props: ["id", "manager"],
  data() {
    return {
      loading: false,
      show: false,
      selectedManager: null,
    };
  },
  mounted() {
    this.selectedManager = this.manager;
  },
  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    change() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangeManager,
          variables: {
            employeeId: this.id,
            managerId:
              (this.selectedManager && this.selectedManager.id) || null,
          },
        })
        .then((res) => {
          this.$emit("refresh");
          this.$emit("manager_changed", res.data.employee.manager);
          this.hide();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    hide() {
      this.show = false;
    },
  },
  apollo: {
    employees: {
      query: EmployeesQuery,
      variables() {
        return {
          queryAll: true,
          queryAllShifts: true,
        };
      },
      skip() {
        return !this.show;
      },
    },
  },
};
</script>
